import { FC } from 'react';
import classNames from 'classnames';

import { NumberSignEnum } from '../../../../lib/enums';
import { CharacterEnum } from '../../../../lib/enums/character.enum';
import TradePriceCache from '../../../../lib/store-util/TradePriceCache';
import { getPriceColorByDirection } from '../../../../lib/util/ChartingHelpers';
import { formatCurrencyBySymbol, formatNumberWithSuffix } from '../../../../lib/util/DataHelpers';
import { INVALID_VALUE } from '../../../../lib/util/types';

import { MarketCapRow } from '../../MarketCapRadar.types';

import styles from '../../MarketCapRadar.module.scss';

const LOADING_PRICE_WIDTH = 40;
const LOADING_CHANGE_WIDTH = 50;

type Props = { item: MarketCapRow, isLoading: boolean };

const MarketCapPriceAndChange: FC<Props> = ({ item, isLoading }: Props): JSX.Element => {
  const { changesPercentage, lookupSymbol, currencySymbol } = item;
  const { currentPrice, changePercent, direction } = TradePriceCache.use(lookupSymbol, 'SymbolTradeInfoCard');
  const isReduction = (changesPercentage ?? 0) < 0;

  if (!item.price) {
    return <>{INVALID_VALUE}</>;
  }

  const color = getPriceColorByDirection(direction);

  return (
    <div className={styles.priceAndChangeContainer}>
      {isLoading ? (
        <>
          <div
            className={classNames(styles.loadingComponent, styles.loadingComponentMargin)}
            style={{ width: LOADING_PRICE_WIDTH }}
          />
          <div className={styles.loadingComponent} style={{ width: LOADING_CHANGE_WIDTH }} />
        </>
      ) : (
        <>
          <span className={GlobalClassesEnum.CommonBody1Text}>
            {formatCurrencyBySymbol(currentPrice ?? item.price, currencySymbol)}
          </span>
          {currentPrice ? (
            <span style={{ color }}>
              {direction}
              {changePercent}
            </span>
          ) : (
            <span className={classNames(
              GlobalClassesEnum.CommonBody1Text,
              isReduction ? styles.negative : styles.positive,
            )}>
              {!isReduction && NumberSignEnum.Positive}
              {formatNumberWithSuffix(changesPercentage, CharacterEnum.Percent)}
            </span>
          )}
        </>
      )}
    </div>
  );
};

export default MarketCapPriceAndChange;
